import { render } from "./CounterSection.vue?vue&type=template&id=51133790"
import script from "./CounterSection.vue?vue&type=script&lang=js"
export * from "./CounterSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__